/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAnalyticsDataSchema = z.object({
	period: z.object({ startDate: z.string(), endDate: z.string() }),
	totalOutbound: z.number(),
	totalInbound: z.number(),
	deliveredCount: z.number(),
	readCount: z.number(),
	failedCount: z.number(),
	deliveryRate: z.number(),
	readRate: z.number(),
	candidatesContacted: z.number(),
	candidatesReplied: z.number(),
	replyRate: z.number(),
	templateBreakdown: z.array(
		z.object({
			templateId: z.string().nullable(),
			templateName: z.string().nullable(),
			sentCount: z.number(),
			deliveredCount: z.number(),
			readCount: z.number(),
			failedCount: z.number(),
		}),
	),
})

export type WhatsAppAnalyticsDataSchema = z.infer<typeof whatsAppAnalyticsDataSchema>
